@if (title) {
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
  </div>
}

<div class="modal-body">
  <div class="mb-3">
    <ngb-progressbar
      type="primary"
      [value]="percent ?? 0"
      [max]="100"
      [striped]="true"
      [animated]="true"
    >
    </ngb-progressbar>
  </div>

  @if (status || percent != null) {
    <div class="mb-3 row">
      <div
        class="input-group col-sm-12 div-wrapper d-flex justify-content-center align-items-center"
      >
        @if (status) {
          {{ status }}
        } @else {
          {{ percent }}%
        }
      </div>
    </div>
  }

  @if (completionTimeFromNow) {
    <div class="mb-3 text-center">
      Time remaining: {{ completionTimeFromNow }}
    </div>
  }
</div>
